import { type Instance, types, type SnapshotOrInstance } from "@gadgetinc/mobx-quick-tree";
import { ShopifyLegacyPartnerAppConfig } from "./ShopifyLegacyPartnerAppConfig";
import { ShopifyBasePartnerConfig } from "./ShopifyBasePartnerConfig";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
export const ShopifyLegacyPartnerConnectionConfig = ShopifyBasePartnerConfig("ShopifyConfig", ShopifyLegacyPartnerAppConfig)
  .props({
    appConfigs: types.map(ShopifyLegacyPartnerAppConfig),
  })
  .views((self) => ({
    get appConfigsAsArray(): Instance<typeof ShopifyLegacyPartnerAppConfig>[] {
      return Array.from(self.appConfigs.values());
    },
  }))
  .actions((self) => ({
    putAppConfig(config: SnapshotOrInstance<typeof ShopifyLegacyPartnerAppConfig>): Instance<typeof ShopifyLegacyPartnerAppConfig> {
      return self.appConfigs.put(config);
    },
    removeAppConfig(configKey: string): boolean {
      return self.appConfigs.delete(configKey);
    },
  }));
